import { memo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from '@components/ShopTheLook/ShopTheLook.styles';
import RenderMedia from '@utils/RenderMedia';
import ArrangementProductState from '@features/categories/mobx/state/ArrangementProductState';
import ProductGalleryBlockModalButton from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModalButton/ProductGalleryBlockModalButton';
import 'react-loading-skeleton/dist/skeleton.css';
type PropsType = {
  arrangementProduct: ArrangementProductState | null;
  getModalData?: (arrangementProduct: ArrangementProductState) => void;
};
const ShopTheLook = memo(({
  arrangementProduct,
  getModalData = () => null
}: PropsType) => {
  const [isHoverImage, setIsHoverImage] = useState(false);
  if (!arrangementProduct || !arrangementProduct.image) {
    return null;
  }
  const handleOnClick = () => {
    if (arrangementProduct && arrangementProduct.productsCount) {
      getModalData(arrangementProduct);
    }
  };
  return <div sx={styles.container}>
      {arrangementProduct ? <button onClick={() => handleOnClick()} onMouseEnter={() => setIsHoverImage(true)} onMouseLeave={() => setIsHoverImage(false)} sx={styles.button(!!arrangementProduct.productsCount)} type="button" className="shopthelook">
          {arrangementProduct.productsCount > 0 && <ProductGalleryBlockModalButton isExpanded={isHoverImage} />}
          <div sx={styles.containerImage}>
            {arrangementProduct.image && RenderMedia(arrangementProduct.image, arrangementProduct.video, true, arrangementProduct.imageWithBlur.blur ? {
          image: arrangementProduct.imageWithBlur.image,
          blur: arrangementProduct.imageWithBlur.blur
        } : undefined)}
          </div>
        </button> : <Skeleton count={1} sx={styles.shopTheLookSkeleton} />}
    </div>;
});
ShopTheLook.displayName = 'ShopTheLook';
export default ShopTheLook;